import { testimonials } from '@/mocks/vigorbuy';

export default function TestimonialsSection() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-6 h-px bg-accent-400"></div>
            <span className="text-xs font-semibold text-accent-600 uppercase tracking-wider">
              User Reviews
            </span>
            <div className="w-6 h-px bg-accent-400"></div>
          </div>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 tracking-tight">
            What Buyers Say
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.slice(0, 2).map((t) => (
            <div
              key={t.name}
              className="bg-background-50 rounded-lg p-6 md:p-7 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={t.avatarUrl}
                  alt={t.name}
                  className="w-12 h-12 rounded-full object-cover"
                  title={`${t.name} - VigorBuy Spreadsheet review`}
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-950 whitespace-nowrap">
                    {t.name}
                  </p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-400 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                &ldquo;{t.quote}&rdquo;
              </p>
            </div>
          ))}

          <div className="relative rounded-lg overflow-hidden aspect-[4/3] md:aspect-auto">
            <img
              src={testimonials[2].avatarUrl}
              alt={testimonials[2].name}
              className="w-full h-full object-cover"
              title={`${testimonials[2].name} - VigorBuy Spreadsheet review`}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <p className="text-sm font-semibold text-background-50">{testimonials[2].name}</p>
              <p className="text-xs text-background-200">{testimonials[2].role}</p>
            </div>
          </div>

          <div className="md:col-span-2 relative rounded-lg overflow-hidden">
            <img
              src={testimonials[3].avatarUrl}
              alt={testimonials[3].name}
              className="w-full h-48 object-cover"
              title={`${testimonials[3].name} - VigorBuy Spreadsheet review`}
            />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-600/80 to-transparent"></div>
            <div className="absolute left-0 bottom-0 p-6 max-w-md">
              <p className="text-sm font-semibold text-background-50">{testimonials[3].name}</p>
              <p className="text-xs text-background-200 mb-2">{testimonials[3].role}</p>
              <p className="text-sm text-background-100 leading-relaxed">
                &ldquo;{testimonials[3].quote}&rdquo;
              </p>
            </div>
          </div>

          <div className="bg-background-50 rounded-lg p-6 md:p-7 flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <img
                src={testimonials[4].avatarUrl}
                alt={testimonials[4].name}
                className="w-12 h-12 rounded-full object-cover"
                title={`${testimonials[4].name} - VigorBuy Spreadsheet review`}
              />
              <div>
                <p className="text-sm font-semibold text-foreground-950 whitespace-nowrap">
                  {testimonials[4].name}
                </p>
                <p className="text-xs text-foreground-500">{testimonials[4].role}</p>
              </div>
            </div>
            <div className="flex gap-0.5">
              {Array.from({ length: testimonials[4].rating }).map((_, i) => (
                <i key={i} className="ri-star-fill text-accent-400 text-sm"></i>
              ))}
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              &ldquo;{testimonials[4].quote}&rdquo;
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}